<div [formGroup]="form" [ngClass]="{ 'input-container': !removeInputContainerClass }" id="edit-attributes-container">
	<ng-container *ngIf="!twoColumns">
		<div *ngFor="let input of inputs" class="fullsize">
			<stages-input [form]="form" [input]="input"></stages-input>
		</div>
	</ng-container>
	<ng-container *ngIf="twoColumns">
		<div *ngFor="let input of inputs; let i = index" class="fullsize">
			<div class="form-group" *ngIf="i % 2 === 0">
				<div class="input-container md">
					<stages-input [form]="form" [input]="inputs[i]"></stages-input>
				</div>
				<div class="input-container md">
					<stages-input *ngIf="i + 1 < inputs.length" [form]="form" [input]="inputs[i + 1]"></stages-input>
				</div>
			</div>
		</div>
	</ng-container>
</div>
